import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    const finish = (user) => {
      window.history.replaceState(null, "", window.location.pathname);
      if (user) {
        setUser(user);
        navigate(user.role === "professional" ? "/pro/dashboard" : "/dashboard", { replace: true, state: { user } });
      } else {
        navigate("/login", { replace: true });
      }
    };
    if (!sessionId) return finish(null);
    api.post("/auth/session", { session_id: sessionId })
      .then(({ data }) => finish(data))
      .catch(() => finish(null));
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-navy flex items-center justify-center" data-testid="auth-callback-loading">
      <div className="text-center">
        <span className="inline-block w-10 h-10 border-2 border-flame border-t-transparent rounded-full animate-spin" />
        <p className="text-white/60 mt-4 text-sm">Signing you in…</p>
      </div>
    </div>
  );
}
